import React from 'react';

const Benefits = () => (
	<div className="container main">
		<h2>ポータルの特長</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>OECD <em>GlobalRecalls</em>ポータルを使用する利点は何ですか？?</h4>
				<p>
					<strong>政府機関</strong>にとって、このポータルは、製品リコールに関する情報共有を集中的かつ迅速に世界規模で強化することで多くのメリットをもたらします。
					当局は、特に<a href="https://globalrecalls.oecd.org/#/dashboard?lang=ja">インタラクティブなダッシュボード</a>を介して新たな傾向を追跡し、対応が必要かもしれない自国・地域の消費者へのリスクを特定することができます。
					グローバルな製造業のサプライチェーンと海外業者からのオンラインショッピングの増加は、安全上の問題がある場合、複数の国・地域で製品のリコールが必要になる可能性があることを意味します。
				</p>
				<p>
					ポータルは共通の製品分類法を使用しており、当局独自の国内リコールデータベースと簡単に統合できます。
					また、政府や一般の方がポータルサイトのデータを詳しく調べたい場合は、<a href="https://globalrecalls.oecd.org/#/admin?lang=ja">アラートのダウンロード（API）</a>を利用することができます。
				</p>
				<p>
					特に製品の<strong>製造者</strong>などの<strong>企業</strong>にとって、このポータルはいち早く安全性の問題に対処できるよう有益な情報を提供し、その結果、事故の発生件数を抑えることで事故関連のコストを削減できます。
					海外から消費者製品を輸入している企業も、他の国・地域の製品のリコール状況を確認することで利益を得ることができる可能性があります。
					<strong>また、小売業者やオンラインマーケットプレイスも、このポータルを参照することで、</strong>安全性に問題のある製品を市場から排除するためにより迅速な対応をすることができます。
				</p>
				<p>また、製品を比較検討したい<strong>消費者</strong>のために、このポータルにはモバイル版のウェブサイトも用意されており、外出先でも簡単に製品のリコール状況を確認することができます。</p>
			</div>
		</div>
	</div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/views/static/ja/benefits.js